import React from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import DetailGoogleMapComponent from "../../../../components/common/map/DetailGoogleMap";
import { MapLogo } from "../../../../assets/logo/MapLogo";
import S from "../../../../assets/stylesheets/experience/sections/ExperienceMap.module.css";

export default function ExperienceMap({ location }) {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY,
  });

  if (!location) return null;
  const lat = parseFloat(location.latitude);
  const lng = parseFloat(location.longitude);
  if (!isFinite(lat) || !isFinite(lng)) return null;
  if (loadError) return <div>Map failed to load</div>;
  if (!isLoaded) return <div>Loading map…</div>;

  const coords = { lat, lng };
  const markers = [
    {
      id: location.id || 1,
      position: coords,
      Component: MapLogo,
      onClick: () => {},
      radius: 200,
    },
  ];

  return (
    <div className={S["exp-map-section"]}>
      <h2 className={S["exp-section-title"]}>Where you'll be</h2>
      <DetailGoogleMapComponent
        markers={markers}
        mapContainerStyle={{ height: "400px", width: "100%" }}
      />
    </div>
  );
}
